<rk-form-field class="planning-date-select--field">
  <mat-icon
    class="planning-date-select--icon"
    fontSet="fas"
    fontIcon="fa-calendar-alt"
  ></mat-icon>
  <input
    class="planning-date-select--input"
    type="text"
    rkDaterangepicker
    readonly
    rkInput
    [formControl]="selectedDate"
    [singleDatePicker]="true"
    [value]="calendarDatesChanged?.formattedRange"
    [autoApply]="true"
    [updateInputValue]="false"
    (datesUpdated)="datesUpdated($event)"
  />
</rk-form-field>
